import { CircuitInfoErrors } from "../objects/circuitInfoErrors";
import { Column } from "../objects/column";
import { FlightParams, TariffLetter } from "../objects/flightParams";
import { FlightParamsErrors } from "../objects/flightParamsErrors";
import { FlightParamsListConfiguration } from "../objects/flightParamsListConfiguration";
import { FlightParamsListCriteria } from "../objects/flightParamsListCriteria";
import { FlightParamsListFiltersCriteria } from "../objects/flightParamsListFiltersCriteria";
import { FlightParamsLocalized } from "../objects/flightParamsLocalized";

export const TARIFF_LETTERS: TariffLetter[] = ['A', 'F', 'P', 'I', 'Z', 'D', 'J', 'C', 'M', 'N', 'T', 'G', 'L', 'K', 'H', 'Q', 'V', 'X', 'B', 'S', 'Y', 'W', 'O', 'E', 'R', 'U'];

export const CLIENT_TYPE: number[] = [1, 2, 5];

export const EMPTY_FLIGHT_PARAMS: FlightParams = {
    id: 0,
    circuit: null,
    disallowed_flight: false,
    allowed_airline: [],
    disallowed_airline: [],
    allow_stopovers: true,
    max_stops: '',
    max_hour_spent_on_stopover: '',
    number_of_bags: [],
    change_airport: false,
    start_departure_time: '',
    end_departure_time: '',
    start_arrival_time: '',
    end_arrival_time: '',
    period: [],
    departure_dow: [0, 1, 2, 3, 4, 5, 6],
    without_transport_arrival_dow: [0, 1, 2, 3, 4, 5, 6],
    arrival_dow: [0, 1, 2, 3, 4, 5, 6],
    ndc_TO_offer: true,
    public_ndc_offer: true,
    standard_TO_offer: true,
    public_standard_offer: true,
    allow_domestic_flights: true,
    allow_number_of_allotment: false,
    created_date: new Date(),
    modified_date: new Date(),
    creator: null,
    last_author: null,
    allowed_stopovers_airport: [],
    disallowed_stopovers_airport: [],
    allowed_departure_airport: [],
    gds_source: false,
    allow_manual_flight: false,
    assigned_trip: "CIRCUIT_PACKAGES",
    disallowed_departure_airport: [],
    allowed_arrival_airport: [],
    disallowed_arrival_airport: [],
    cabin: ['ECONOMY', 'PREMIUM_ECONOMY', 'BUSINESS', 'FIRST'],
    tariff_letters: TARIFF_LETTERS,
    providers: [],
    flight_duration_min: "",
    flight_duration_max: "",
    start_departure_time_inbound: "",
    end_departure_time_inbound: "",
    start_arrival_time_inbound: "",
    end_arrival_time_inbound: "",
    allowed_client_type: CLIENT_TYPE,
    hide_gds_response_on_manual_response: false,
    display_manual_response_first: false,
    localization: [],
    name: "",
    allowed_stopovers_list: null,
    disallowed_stopovers_list: null,
    allowed_departure_list: null,
    disallowed_departure_list: null,
    allowed_arrival_list: null,
    disallowed_arrival_list: null,
    allowed_return_airport: null,
    circuit_version: null,
    circuit_variant: null
};


export const EMPTY_FLIGHT_PARAMS_ERRORS: FlightParamsErrors = {
    disallowed_flight_error: "",
    circuit_error: "",
    flight_duration_max_error: "",
    periods_error: []
};

export const EMPTY_FLIGHT_PARAMS_FILTERS: FlightParamsListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_FLIGHT_PARAMS_LIST_CRITERIA: FlightParamsListCriteria = {
    limit: 100000,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_FLIGHT_PARAMS_FILTERS,
    search: ''
};

export const EMPTY_CIRCUIT_INFO_ERRORS: CircuitInfoErrors = {
    reference: "",
    destination: "",
    name: ""
};



export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'unauthorized-flight',
    field_name: 'UNAUTHORIZED_FLIGHT',
    checked: true,
    order_by: 'disallowed_flight',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'version',
    field_name: 'CIRCUIT_VERSION',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'variant',
    field_name: 'CIRCUIT_VARIANT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_FLIGHT_PARAMS_LIST_CONFIGURATION: FlightParamsListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const EMPTY_FLIGHT_PARAMS_LOCALIZED: FlightParamsLocalized = {
    name: "",
    locale: 0
};


export const CIRCUIT_FLIGH_PARAMS_MODULE = 'CIRCUIT_FLIGHT_PARAMS_MODULE';
export const CIRCUIT_DEPARTURE_AIRPORTS_MODULE = 'CIRCUIT_DEPARTURE_AIRPORTS_MODULE';